import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const res = await login(form.email, form.password);
    setLoading(false);
    if (res.success) {
      if (res.user?.role === "admin") {
        navigate("/admin");
      } else {
        setError("This account does not have admin access.");
      }
    } else {
      setError(res.error);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-xl shadow-sm p-8">
        <div className="text-center mb-8">
          <ShieldCheck className="h-8 w-8 text-brandblue-600 mx-auto mb-3" strokeWidth={1.5} />
          <h1 className="text-2xl font-display font-medium text-slate-900">Admin Login</h1>
          <p className="text-sm text-slate-500 mt-1">Sign in to the True Impact Peptides admin console.</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div><Label>Email</Label><Input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="admin-login-email-input" /></div>
          <div><Label>Password</Label><Input type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="admin-login-password-input" /></div>
          {error && <p className="text-xs text-red-500" data-testid="admin-login-error">{error}</p>}
          <Button type="submit" disabled={loading} className="w-full rounded-full btn-lift" data-testid="admin-login-submit-btn">
            {loading ? "Signing In..." : "Admin Login"}
          </Button>
        </form>

        <div className="text-center mt-6">
          <Link to="/" className="text-xs text-slate-400 hover:text-brandblue-600" data-testid="admin-login-back-link">← Back to site</Link>
        </div>
      </div>
    </div>
  );
}
